<template>
	<div class="pages">
		<div class="content">
			<div class="title">
				关于站点
			</div>
			<div class="font">
				一个吃臭豆腐的肥仔程序员
			</div>
			<div class="font">

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		methods: {

		},
	}
</script>

<style lang="less" scoped>
	.pages {
		width: 100%;

		.content {
			padding: 30px 20px;
			background-color: #ffffff;
			margin-top: 10px;
			border-radius: 5px;

			.font {
				font-size: 16px;
			}
		}
	}
</style>
